<template>
  <div>
    <Return />
    <div class="bodyControll">
      <div class="steps">
        <Step :step="0" />
      </div>
      <div class="formControll">
        <el-form
          label-position="top"
          :model="form"
          :rules="rules"
          ref="form"
          label-width="120px"
          class="formTotal"
        >
          <div class="module">
            <div class="title">1. 基本信息(必填)</div>
            <div>
              <div class="remark">
                <img src="@/assets/img/ico_t.png" alt="" />&nbsp;
                首次登记，企业名称和信用代码如有变动，联系后台处理，联系电话&nbsp;&nbsp;<span
                  >0871-68184040</span
                >
              </div>
              <el-row style="margin-top: 18px">
                <el-col :span="12">
                  <el-form-item label="企业名称">
                    <el-input
                      disabled
                      v-model="userinfo.company_info.name"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="企业社会信用代码证号"
                    style="margin-left: 20px"
                  >
                    <el-input
                      disabled
                      v-model="userinfo.company_info.code"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--              三级下拉-->
              <el-row v-if="hasload">
                <el-col :span="8">
                  <el-form-item label="企业地址-省/市/区县" prop="province">
                    <el-cascader
                      @change="skkHandlerChangArea"
                      :props="skk_area"
                      v-model="form.area"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    label="企业地址-详细地址"
                    style="margin-left: 20px"
                    prop="address"
                  >
                    <el-input
                      v-model="form.address"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="成立时间" prop="com_create_time">
                    <el-date-picker
                      v-model="form.com_create_time"
                      type="date"
                      value-format="yyyy-MM-dd"
                      placeholder="请选择成立时间"
                    >
                    </el-date-picker>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    prop="eco_type"
                    label="经济类型"
                    style="margin-left: 20px"
                  >
                    <el-select v-model="form.eco_type" placeholder="请选择">
                      <!--                 这里和后台约定传中文字符串-->
                      <el-option
                        v-for="item in eco_type"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    prop="capital"
                    label="注册资金（万元）"
                    style="margin-left: 20px"
                  >
                    <el-input
                      placeholder="请输注册资金"
                      v-model="form.capital"
                      type="number"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <!--              <el-row-->
              <!--                v-if="hasload"-->
              <!--                v-show="memberType === 2 || memberType === 4"-->
              <!--              >-->
              <el-row
                v-if="hasload"
                v-show="memberType == '2' || memberType == '4'"
              >
                <el-col :span="8">
                  <el-form-item label="在滇办公地址-省/市/区县" prop="y_area">
                    <el-cascader
                      v-model="form.y_area"
                      @change="skkHandlerChang_yArea"
                      :props="skk_y_area"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="16">
                  <el-form-item
                    prop="y_address"
                    label="在滇办公地址-详细地址"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.y_address"
                      placeholder="请输入详细地址"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row v-show="memberType == '2' || memberType == '4'">
                <el-col :span="8">
                  <el-form-item prop="y_phone" label="在滇办公电话">
                    <el-input
                      placeholder="请输入电话号码"
                      v-model="form.y_phone"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!--              <el-row-->
              <!--                style="position: relative"-->
              <!--                v-show="memberType == 1 || memberType == 2"-->
              <!--              >-->
              <!--                <el-col :span="12">-->
              <!--                  <el-form-item label="原造价资质等级">-->
              <!--                    &lt;!&ndash;                    <el-input disabled :value="s_level | levelText"></el-input>&ndash;&gt;-->
              <!--                    <el-select v-model="s_level" placeholder="请选择" disabled>-->
              <!--                      &lt;!&ndash;                      这里后台传的是数字，二造是字符串所以输入框不出现文字直接数字&ndash;&gt;-->
              <!--                      <el-option-->
              <!--                        v-for="item in options"-->
              <!--                        :key="item.value"-->
              <!--                        :label="item.label"-->
              <!--                        :value="item.value"-->
              <!--                      >-->
              <!--                      </el-option>-->
              <!--                    </el-select>-->
              <!--                  </el-form-item>-->
              <!--                </el-col>-->
              <!--                <el-col :span="12">-->
              <!--                  <el-form-item-->
              <!--                    label="原造价资质证书编号"-->
              <!--                    style="margin-left: 20px"-->
              <!--                  >-->
              <!--                    <el-input disabled v-model="s_code"></el-input>-->
              <!--                  </el-form-item>-->
              <!--                </el-col>-->
              <!--              </el-row>-->
            </div>
          </div>

          <div class="module" style="margin-top: 50px">
            <div class="title">2. 负责人信息(必填)</div>
            <div>
              <el-row>
                <el-col :span="8">
                  <el-form-item label="法定代表人姓名" prop="legal_name">
                    <el-input
                      placeholder="请输入姓名"
                      v-model="form.legal_name"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="法定代表人联系电话"
                    prop="legal_tel"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.legal_tel"
                      placeholder="请输入联系电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="法定代表人职称"
                    prop="legal_title"
                    style="margin-left: 20px"
                  >
                    <!--                    <el-input-->
                    <!--                      v-model="form.legal_title"-->
                    <!--                      placeholder="请输入职称"-->
                    <!--                    ></el-input>-->
                    <el-select v-model="form.legal_title" placeholder="请选择">
                      <el-option
                        v-for="item in legalTitle"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item prop="technical_name" label="技术负责人姓名">
                    <el-input
                      v-model="form.technical_name"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    prop="technical_tel"
                    label="技术负责人联系电话"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.technical_tel"
                      placeholder="请输入联系电话"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="技术负责人职称"
                    prop="technical_title"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.technical_title"
                      placeholder="请输入职称"
                    ></el-input>
                    <!--                    <el-select-->
                    <!--                      v-model="form.technical_title"-->
                    <!--                      placeholder="请选择"-->
                    <!--                    >-->
                    <!--                      <el-option-->
                    <!--                        v-for="item in technicalTitle"-->
                    <!--                        :key="item.value"-->
                    <!--                        :label="item.label"-->
                    <!--                        :value="item.value"-->
                    <!--                      ></el-option>-->
                    <!--                    </el-select>-->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    prop="technical_code"
                    label="技术负责人一级注册造价工程师证书编号"
                  >
                    <el-input
                      v-model="form.technical_code"
                      placeholder="请输入证书编号"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item prop="contact_name" label="企业联系人姓名">
                    <el-input
                      v-model="form.contact_name"
                      placeholder="请输入姓名"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label="企业联系人电话（传真）"
                    prop="contact_tel"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.contact_tel"
                      placeholder="请输入电话（传真）"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    prop="contact_email"
                    label="电子邮箱"
                    style="margin-left: 20px"
                  >
                    <el-input
                      v-model="form.contact_email"
                      placeholder="请输入电子邮箱"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>

          <div class="module" style="margin-top: 50px">
            <div class="title">3. 资质信息(必填)</div>
            <div>
              <div class="upLoadControll">
                <div class="remarkControll">
                  <img src="@/assets/img/warn.png" alt="" />
                  <div class="remarkT">
                    请上传真实有效的资质信息和企业承诺书，信息将长期保存，若存在弄虚作假行为，将承担由此带来的一切后果和责任。<br />
                    1.
                    上传图片附件大小不得超过500KB，图片格式为jpg/jpeg/png。<br />
                    2.
                    上传图片内容需清晰无误，无涂改、遮挡，若图片模糊或尺寸较小可能会影响系统判断。
                    <br />3.
                    企业承诺书填写方式为电子版文档加手写签名和单位公章。
                  </div>
                </div>
              </div>
              <el-row style="margin-top: 30px">
                <el-col :span="12">
                  <el-form-item label="营业执照" prop="license_image">
                    <Upload :files.sync="form.license_image"></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="上传企业承诺书"
                    prop="promise_image"
                    class="link"
                  >
                    <a
                      :href="
                        $api_imageUrl + 'api/common/download?symbol=com_promise'
                      "
                      target="_blank"
                      class="load"
                      >下载企业承诺书</a
                    >
                    <Upload :files.sync="form.promise_image"></Upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="法定代表人身份证(正面)"
                    prop="legal_idcard_f_image"
                  >
                    <Upload :files.sync="form.legal_idcard_f_image"></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="法定代表人身份证(反面)"
                    prop="legal_idcard_b_image"
                  >
                    <Upload :files.sync="form.legal_idcard_b_image"></Upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="技术负责人身份证(正面)"
                    prop="technical_idcard_f_image"
                  >
                    <Upload
                      :files.sync="form.technical_idcard_f_image"
                    ></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="技术负责人身份证(反面)"
                    prop="technical_idcard_b_image"
                  >
                    <Upload
                      :files.sync="form.technical_idcard_b_image"
                    ></Upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12">
                  <el-form-item
                    label="企业联系人身份证(正面)"
                    prop="contact_idcard_f_image"
                  >
                    <Upload :files.sync="form.contact_idcard_f_image"></Upload>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    label="企业联系人身份证(反面)"
                    prop="contact_idcard_b_image"
                  >
                    <Upload :files.sync="form.contact_idcard_b_image"></Upload>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="12" v-if="this.form.legal_title != '无'">
                  <el-form-item
                    label="法定代表人职称证"
                    prop="legal_title_image"
                  >
                    <Upload :files.sync="form.legal_title_image"></Upload>
                  </el-form-item>
                </el-col>
                <!--                <el-col :span="12" v-if="this.form.technical_title != '无'">-->
                <el-col :span="12">
                  <el-form-item
                    label="技术负责人职称证"
                    prop="technical_title_image"
                  >
                    <Upload :files.sync="form.technical_title_image"></Upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <div class="btnControll">
                <div class="save" @click="save(1)">保存</div>
                <div class="go" @click="next()">下一步</div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  enterprise,
  getSaveStatus,
  regBaseInfo,
  skk_set_cache,
} from "@/api/company.js";

import Return from "@/components/record/Return";
import Step from "@/components/record/Step";
import Upload from "@/components/record/Upload";
// import homeIndex from "@/views/home/record/index";
import { get3levelArea } from "@/api";
//import AreaSelect from "@/components/areaSelecttree";

export default {
  name: "homeCreate",
  components: {
    Return,
    Step,
    Upload,
  },

  // filters: {
  //   levelText(val) {
  //     const s_level = {
  //       1: "甲级",
  //       2: "乙级",
  //       3: "丙级",
  //     };
  //     return s_level[val];
  //   },
  // },
  computed: {
    ...mapState(["userinfo", "skk_will_be_year"]),
  },
  mounted() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  async created() {
    this.memberType = this.userinfo.company_info.member_type;

    if (!this.userinfo.is_set_password) {
      //this.$message.error("请修改密码！");
      // console.log("1---------------");
      this.$router.push({ name: "setAccount" });
      return false;
    } else if (!this.userinfo.company_info.phone) {
      // this.$message.error("请绑定手机号码！");
      // console.log("2-------------");
      this.$router.push({ name: "setAccount" });
      return false;
    } else if (!this.userinfo.phone && !this.userinfo.is_set_password) {
      // this.$message.error("请修改密码及绑定手机号码！");
      // console.log("3-------------");
      this.$router.push({ name: "setAccount" });
      return false;
    }

    this.skk_area.lazyLoad = this.skkLazyLoadArea;
    this.skk_y_area.lazyLoad = this.skkLazyLoad_yArea;
    this.form.year = this.skk_will_be_year;

    //有record_id被审核过，就去拿历史记录的详情，而不是缓存
    if (this.$route.query.record_id) {
      this.record_id = this.$route.query.record_id;
    }
    // 页面中加载数据
    const tempreData = await this.saveStatus();
    // console.log(tempreData, "tempreData-----");
    // 如果缓存个为空的时候就进行企业信息的查询
    if (tempreData === false) {
      // console.log("进行企业信息的查询");
      await this.init();
    } else {
      // await this.init(false);
    }
    // 如果企业信息为空就尝试从登录信息里面拿出来放到表单里面
    if (!this.form.name) {
      this.form.name = this.userinfo.company_info.name;
    }
    if (!this.form.code) {
      this.form.code = this.userinfo.company_info.code;
    }

    if (this.$route.query.text) {
      this.text = this.$route.query.text;
    }
    this.hasload = true;
  },
  watch: {
    form: {
      handler(val) {
        for (let item in val) {
          if (val[item] && item.includes("_image")) {
            this.$refs.form.clearValidate(item);
          }
        }
      },
      deep: true,
    },
  },
  data() {
    return {
      hasload: false,
      record_id: null, // 记录ID
      skk_area: {
        lazy: true,
        lazyLoad: null,
      },
      skk_y_area: {
        lazy: true,
        lazyLoad: null,
      },
      //isNewUser 该字段判断只能再账户设置那里使用
      // isNewUser: false, //是否是新用户
      memberType: "", //省内 省外 用户判断
      saveData: {}, //是否有储存状态
      //法人 职称选择
      legalTitle: [
        {
          label: "无",
          value: "无",
        },
        {
          label: "技术员",
          value: "技术员",
        },
        {
          label: "助理工程师",
          value: "助理工程师",
        },
        {
          label: "工程师",
          value: "工程师",
        },
        {
          label: "高级工程师",
          value: "高级工程师",
        },
        {
          label: "正高级工程师",
          value: "正高级工程师",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      //技术负责人 职称选择
      technicalTitle: [
        {
          label: "无",
          value: "无",
        },
        {
          label: "技术员",
          value: "技术员",
        },
        {
          label: "助理工程师",
          value: "助理工程师",
        },
        {
          label: "工程师",
          value: "工程师",
        },
        {
          label: "高级工程师",
          value: "高级工程师",
        },
        {
          label: "正高级工程师",
          value: "正高级工程师",
        },
        {
          label: "其他",
          value: "其他",
        },
      ],
      eco_type: [
        {
          value: "国有经济",
          label: "国有经济",
        },
        {
          value: "集体经济",
          label: "集体经济",
        },
        {
          value: "私营经济",
          label: "私营经济",
        },
        {
          value: "个体经济",
          label: "个体经济",
        },
        {
          value: "联营经济",
          label: "联营经济",
        },
        {
          value: "股份制",
          label: "股份制",
        },
        {
          value: "外商投资",
          label: "外商投资",
        },
        {
          value: "港澳台投资",
          label: "港澳台投资",
        },
        {
          value: "有限责任",
          label: "有限责任",
        },
        {
          value: "其它经济",
          label: "其它经济",
        },
      ],
      options: [
        {
          value: 0,
          label: "未定级",
        },
        {
          value: 1,
          label: "甲级",
        },
        {
          value: 2,
          label: "乙级",
        },
        {
          value: 3,
          label: "丙级",
        },
      ],
      // s_level: "", //原造价资质等级
      // s_code: "", //证书编号
      rules: {
        address: [
          {
            required: true,
            message: "请输入企业所在详细地址",
            trigger: "blur",
          },
        ],
        province: [
          {
            required: true,
            message: "请选择企业地址-省/市/区县",
            trigger: ["blur", "change"],
          },
        ],
        // y_address: [
        //   {
        //     required: true,
        //     message: "请输入在滇办公详细地址",
        //     trigger: "blur",
        //   },
        // ],
        // y_area: [
        //   {
        //     type: "array",
        //     required: true,
        //     message: "请输入在滇办公地址-省/市/区县",
        //     trigger: "blur",
        //   },
        // ],
        // y_phone: [
        //   {
        //     required: true,
        //     message: "请输入在滇办公电话",
        //     trigger: "blur",
        //   },
        // ],
        com_create_time: [
          {
            required: true,
            message: "请选择成立时间",
            trigger: "blur",
          },
        ],
        capital: [
          { required: true, message: "请输入注册资本", trigger: "blur" },
          // { type: "number", message: "注册资本必须为数字值" },
        ],
        legal_name: [
          {
            required: true,
            message: "请输入法定代表人姓名",
            trigger: "blur",
          },
        ],
        legal_tel: [
          {
            required: true,
            message: "请输入法定代表人联系电话",
            trigger: "blur",
          },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "blur",
          },
        ],
        legal_title: [
          {
            required: true,
            message: "请输入法定代表人职称",
            trigger: "blur",
          },
        ],
        technical_name: [
          {
            required: true,
            message: "请输入技术负责人姓名",
            trigger: "blur",
          },
        ],
        technical_tel: [
          {
            required: true,
            message: "请输入技术负责人联系电话",
            trigger: "blur",
          },
          {
            pattern: /^1\d{10}$/,
            message: "手机号格式不对",
            trigger: "blur",
          },
        ],
        technical_title: [
          {
            required: true,
            message: "请输入技术负责人职称",
            trigger: "blur",
          },
        ],
        technical_code: [
          {
            required: true,
            message: "请输入技术负责人一级注册造价工程师证书编号",
            trigger: "blur",
          },
        ],
        contact_name: [
          {
            required: true,
            message: "请输入企业联系人姓名",
            trigger: "blur",
          },
        ],
        contact_tel: [
          { required: true, message: "请输入企业联系人电话", trigger: "blur" },
        ],
        contact_email: [
          { required: true, message: "请输入企业联系人邮箱", trigger: "blur" },
        ],
        eco_type: [
          { required: true, message: "请输入经济类型", trigger: "blur" },
        ],
        //img
        legal_idcard_f_image: [
          {
            required: true,
            message: "请上传法人身份证正面",
            trigger: "change",
          },
        ],
        legal_idcard_b_image: [
          {
            required: true,
            message: "请上传法人身份证背面",
            trigger: "change",
          },
        ],
        legal_title_image: [
          {
            required: true,
            message: "请上传法人职称",
            trigger: "change",
          },
        ],
        contact_idcard_b_image: [
          {
            required: true,
            message: "请上传企业联系人身份证图片（背面）",
            trigger: "change",
          },
        ],
        contact_idcard_f_image: [
          {
            required: true,
            message: "请上传企业联系人身份证图片（正面）",
            trigger: "change",
          },
        ],
        technical_idcard_f_image: [
          {
            required: true,
            message: "请上传技术负责人身份证图片（正面）",
            trigger: "change",
          },
        ],
        technical_idcard_b_image: [
          {
            required: true,
            message: "请上传技术负责人身份证图片（背面）",
            trigger: "change",
          },
        ],
        license_image: [
          {
            required: true,
            message: "请上传营业执照图片",
            trigger: "change",
          },
        ],
        promise_image: [
          {
            required: true,
            message: "请上传企业承诺书图片",
            trigger: "change",
          },
        ],
        technical_title_image: [
          {
            required: true,
            message: "请上传技术负责任职称证书图片",
            trigger: "change",
          },
        ],
      },
      form: {
        code: "", //企业信用代码
        name: "", //企业名称

        province: "", //省
        city: "", //市
        county: "", //县
        y_province: "", //在滇办公省
        y_city: "", //在滇办公市
        y_county: "", //在滇办公区

        address: "", //企业所在详细地址
        area: "", //企业地址-省/市/区县
        y_address: "", //在滇办公详细地址
        com_create_time: "", //成立时间
        capital: "", //注册资本
        y_phone: "", //在滇办公电话
        legal_name: "", //法定代表人姓名
        legal_tel: "", //法定代表人联系电话
        legal_title: "", //法定代表人职称
        technical_name: "", //技术负责人姓名
        technical_tel: "", //技术负责人联系电话
        technical_title: "", //技术负责人职称
        technical_code: "", //技术负责人一级注册造价工程师证书编号,
        contact_name: "", //企业联系人姓名
        contact_tel: "", //企业联系人电话
        contact_email: "", //企业联系人邮箱
        eco_type: "", //经济类型

        legal_idcard_f_image: "", //法人身份证 正面
        legal_idcard_b_image: "", //法人身份证 背面
        legal_title_image: "", //法人职称
        contact_idcard_b_image: "", //企业联系人身份证图片（背面）
        contact_idcard_f_image: "", //企业联系人身份证图片（正面）
        technical_idcard_f_image: "", //技术负责人身份证图片（正面）
        technical_idcard_b_image: "", //技术负责人身份证图片（背面）
        license_image: "", //营业执照图片
        promise_image: "", //企业承诺书图片
        technical_title_image: "", //技术负责任职称证书图片
        year: "", // 年度
      },
    };
  },
  methods: {
    // async upload() {
    //   const res = await download({
    //     symbol: "com_promise",
    //   });
    //   console.log(res, "download");
    // },
    skkHandlerChangArea(value) {
      // console.log("==========", value);
      this.form.province = value[0] || "";
      this.form.city = value[1] || "";
      this.form.county = value[2] || "";
      if (this.form.province) {
        this.form.area = value;
      }
    },
    async skkLazyLoadArea(node, resolve) {
      const { level } = node;
      const { value } = node;
      let params = {
        level: level + 1,
        id: value,
      };
      const res = await get3levelArea(params);
      const list = [];
      res.map((item) => {
        list.push({
          value: item.name,
          label: item.name,
          leaf: level >= 2,
        });
      });
      resolve(list);
    },
    skkHandlerChang_yArea(value) {
      this.form.y_province = "云南省";
      this.form.y_city = value[0] || "";
      this.form.y_county = value[1] || "";
      if (this.form.y_city) {
        this.form.y_area = value;
      }
    },
    async skkLazyLoad_yArea(node, resolve) {
      let { level } = node;
      const { value } = node;
      level += 1;
      let params = {
        level: level + 1,
        id: value,
      };
      if (!params.id) {
        params.id = "云南省";
      }
      const res = await get3levelArea(params);
      const list = [];
      res.map((item) => {
        list.push({
          value: item.name,
          label: item.name,
          leaf: level >= 2,
        });
      });
      resolve(list);
    },
    //有缓存 和 直接没填写过的 两种角色进入该页面
    async saveStatus() {
      // console.log("李雅婷");
      const res = await getSaveStatus("save");
      // console.log(res, "res");
      if (res) {
        console.log(res, "res");
      }
      //！！！！这里后端是 没保存成功返回空数组给我
      //               有缓存返回给我 对象
      if (res) {
        // console.log("数据来源是缓存");
        this.form = res;

        // 下面是为了表单校验而写的
        // 因为先拿到用户的缓存，可能用户地址这里没填写
        // 拿到的就是["",""]这种，然后赋值给表单，第二次用户提交时地址还是没写
        // 此时表单校验已经是数组有长度的了，就自然通过了

        //省外
        this.form.y_area = [];
        if (this.form.y_city) {
          this.form.y_area.push(this.form.y_city);
          this.form.y_area.push(this.form.y_county);
        }
        //省内
        this.form.area = [];
        if (this.form.province) {
          this.form.area.push(this.form.province);
          this.form.area.push(this.form.city);
          this.form.area.push(this.form.county);
        }

        // console.log(this.form, "this.form.area");

        return true;
      }
      return false;
    },
    // 查是不是有缓存这种状态

    //拿到角色判断 那些表单字段
    async init(form = true) {
      console.log(form);
      let sendData = {};
      if (this.record_id) {
        // console.log(this.record_id, "wwwwwww");
        sendData.record_id = this.record_id;
      }
      // console.log(sendData, "sendData");
      const res = await enterprise(sendData);
      // console.log(res, "=============");
      // this.isNewUser = res.is_new_user;
      // this.s_level = res.s_level;
      // this.s_code = res.s_code;
      // this.memberType = res.member_type;
      // console.log(this.isNewUser, "is_new_user");
      //1=省内老用户,2=省外老用户,3=注册省内,4=注册省外
      //1,2老。3，4新
      //if (form) {
      if (res) {
        this.form = res;
        // console.log(res, "res");
        //判断一下，老用户的法人职称是否有已经填写对的，如果没有就设置为空，让用户自己去选我们规定的下拉里面的
        if (
          res.legal_title == "无" ||
          res.legal_title == "技术员" ||
          res.legal_title == "助理工程师" ||
          res.legal_title == "工程师" ||
          res.legal_title == "高级工程师" ||
          res.legal_title == "正高级工程师" ||
          res.legal_title == "其他"
        ) {
          this.form.legal_title = res.legal_title;
        } else {
          this.form.legal_title = "";
        }
        // console.log(this.form.legal_title, "this.form.legal_title");
        // console.log("if (form)");
        this.form.y_area = []; //省内
        if (this.form.y_city) {
          this.form.y_area.push(this.form.y_city);
          this.form.y_area.push(this.form.y_county);
        }

        //省外
        this.form.area = [];
        if (this.form.province) {
          this.form.area.push(this.form.province);
          this.form.area.push(this.form.city);
          this.form.area.push(this.form.county);
        }
      }
      // console.log("数据来源是企业信息");
    },
    //用户没填写完，保存
    async save(val) {
      //记录保存过，有缓存
      if (!this.form.year) this.form.year = this.skk_will_be_year;
      const res = await skk_set_cache({
        data: { ...this.form },
        flag: "save",
      });
      console.log(res, "res``````````````````");
      //只有单纯的保存时用
      if (val == 1) {
        this.$message.success("保存成功!");
        this.$router.push({ name: "homeIndex" });
      }
    },
    //下一步
    async next() {
      //提交前先请求之前的保存接口，如果有保存的话，用提交确认的那个版本覆盖保存这个
      //参数2代表 不用保存方法里面的那些保存成功的提示语和跳转
      await this.save(2);
      console.log(this.form, "this.form");
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // console.log("进入验证");
          // console.log(this.form.year, "this.form.year");
          if (!this.form.year) {
            // console.log("-------99");
            this.form.year = this.skk_will_be_year;
          }
          // console.log(this.form, "--------------------");
          let sendData = this.form;

          if (this.record_id) {
            sendData.record_id = this.record_id;
          }
          // console.log(sendData, sendData.record_id, "提交的数据");
          // 该方法把上传图片的域名去除 给后端
          let tempImgs = [
            "license_image",
            "promise_image",
            "legal_idcard_f_image",
            "legal_idcard_b_image",
            "legal_title_image",
            "contact_idcard_b_image",
            "contact_idcard_f_image",
            "technical_idcard_f_image",
            "technical_idcard_b_image",
            "technical_title_image",
          ];
          let tepVal = "";
          tempImgs.forEach((item) => {
            // console.log(item, "item");
            // console.log(sendData, "sendData");
            tepVal = sendData[item];
            // console.log(tepVal, "tepVal----------------");
            // TODO 正是站这里没有https(建设厅服务器安装不了https证书)

            if (tepVal) {
              // sendData[item] = tepVal.replace(
              //   /https:\/\/zjzxadmin.jc881.com(\/+)/g,
              //   "/"
              // );
              //正式域名
              sendData[item] = tepVal.replace(
                /http:\/\/zjqyadmin.ynbzde.com(\/+)/g,
                "/"
              );
            }
            //如果法人职称为无，则可以补提交照片，要把缓存中之前的法人职称照片删除
            if (this.form.legal_title == "无") {
              if (item == "legal_title_image") {
                sendData[item] = "";
              }
            }
            // console.log(sendData[item]);
            // console.log(item, "<><><><><>");
          });
          // console.log(sendData);
          const res = await regBaseInfo(sendData);
          // console.log(res, "跳下一步");
          //跳下一步
          setTimeout(() => {
            this.$router.push({
              name: "createStaff",
              query: {
                record_id: res.record_id,
              },
            });
          }, 800);
        } else {
          this.$message.error("请填写完整");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.bodyControll {
  background: #ffffff;
  border-radius: 2px;
  padding: 20px 40px 40px 40px;
  margin-top: 10px;

  .steps {
    border-bottom: 1px solid #dddddd;
    padding: 0 149px 24px;
  }

  .formControll {
    margin-top: 30px;
    width: 100%;

    .module {
      display: flex;

      .title {
        font-size: 12px;
        font-weight: 700;
        color: #333333;
        min-width: 149px;

        .ml20 {
          margin-left: 20px;
        }
      }

      .upLoadControll {
        flex: 1;

        .remarkControll {
          padding: 10px 12px;
          background: #f9f4e8;
          border: 1px solid #f9e9c3;
          border-radius: 2px;
          display: flex;

          img {
            width: 13px;
            height: 13px;
            margin-top: 6px;
          }

          .remarkT {
            font-size: 12px;
            color: #333333;
            margin-left: 5px;
            line-height: 24px;
          }
        }
      }

      .formTotal {
        flex: 1;
      }

      .btnControll {
        display: flex;
        align-items: center;

        div {
          margin-top: 40px;
          width: 100px;
          height: 38px;
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }

        .save {
          background: #d7ddeb;
          color: #333;
        }

        .go {
          background: #f39020;
          color: #fff;
          margin-left: 20px;
        }
      }

      /deep/ .el-form-item__label {
        font-size: 12px;
        color: #666666;
        line-height: unset;
        margin-bottom: 5px;
      }

      /deep/ .el-form--label-top .el-form-item__label {
        padding: unset;
      }
    }
  }

  .timeT {
    font-size: 12px;
    color: #666666;
    line-height: unset;
    margin-bottom: 5px;
    padding: 0 0 10px;
  }

  .link {
    position: relative;

    .load {
      position: absolute;
      width: 84px;
      height: 17px;
      font-size: 12px;
      color: #4379f6;
      top: 10px;
      left: 93px;
    }
  }

  .remark {
    background: #eaf4ff;
    border: 1px solid #d2e7fb;
    border-radius: 2px;
    display: flex;
    align-items: center;
    padding-left: 12px;
    height: 32px;
    font-size: 12px;
    color: #333333;

    span {
      color: rgb(83, 133, 247);
    }

    img {
      width: 13px;
      height: 13px;
    }

    .text {
      font-size: 12px;
      color: #333333;
      margin-left: 5px;
    }
  }
}
</style>
